import { ComponentAPI, Value } from '@philips-emr/tws-core';

class VideoStreamAPI extends ComponentAPI {
  getData(): Record<string, Value> {
    return this.state.data;
  }

  setData(data: Record<string, Value>): void {
    this.setState({ data });
  }

  getEndpoint(): string {
    return this.state.endpoint;
  }

  setEndpoint(endpoint: string): void {
    this.setState({ endpoint });
  }

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }
}

export default VideoStreamAPI;
